/* eslint-disable max-len */
import cx from 'clsx';

// types
// styles
import { useStyles } from './shared/styles';

const CurrencySquare = ({ className, color, onClick }) => {
  const classes = useStyles();
  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M1 0H19C19.2652 0 19.5196 0.105357 19.7071 0.292893C19.8946 0.48043 20 0.734784 20 1V17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H1C0.734784 18 0.48043 17.8946 0.292893 17.7071C0.105357 17.5196 0 17.2652 0 17V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM2 2V16H18V2H2ZM6.5 11H12C12.1326 11 12.2598 10.9473 12.3536 10.8536C12.4473 10.7598 12.5 10.6326 12.5 10.5C12.5 10.3674 12.4473 10.2402 12.3536 10.1464C12.2598 10.0527 12.1326 10 12 10H8C7.33696 10 6.70107 9.73661 6.23223 9.26777C5.76339 8.79893 5.5 8.16304 5.5 7.5C5.5 6.83696 5.76339 6.20107 6.23223 5.73223C6.70107 5.26339 7.33696 5 8 5H9V3H11V5H13.5V7H8C7.86739 7 7.74021 7.05268 7.64645 7.14645C7.55268 7.24021 7.5 7.36739 7.5 7.5C7.5 7.63261 7.55268 7.75979 7.64645 7.85355C7.74021 7.94732 7.86739 8 8 8H12C12.663 8 13.2989 8.26339 13.7678 8.73223C14.2366 9.20107 14.5 9.83696 14.5 10.5C14.5 11.163 14.2366 11.7989 13.7678 12.2678C13.2989 12.7366 12.663 13 12 13H11V15H9V13H6.5V11Z"
        fill={color}
      />
    </svg>
  );
};

export default CurrencySquare;
